import { Button } from '@seiue/ui'
import EquationEditor from 'equation-editor-react'
import React, { useState } from 'react'
import { BlockMath } from 'react-katex'
import styled from 'styled-components'

import { SelectFormula } from './SelectFormula'

/**
 * 编辑公式
 * @param param - 参数
 * @param param.initValue - 初始值
 * @param param.hide - 关闭弹窗
 * @param param.onOk - 确认回调
 * @returns React.ReactNode
 */
export const EditFormula: React.FC<{
  initValue?: string
  hide: () => void
  onOk: (v: string) => void
}> = ({ initValue, hide, onOk }) => {
  const [formulate, setFormulate] = useState<string>(initValue || '')
  const [focusing, setFocusing] = useState<boolean>(false)
  return (
    <Wrapper>
      <Content>
        <SelectFormula
          value={formulate}
          onItemClick={setFormulate}
        />
        <EditorContent
          onClick={(e) => {
            e.stopPropagation()
            setFocusing(true)
          }}
          onFocus={() => {
            setFocusing(true)
          }}
          onBlur={(e) => {
            if (!e.currentTarget.contains(e.relatedTarget)) {
              setFocusing(false)
            }
          }}
        >
          {focusing ? (
            <EquationEditor
              value={formulate}
              onChange={(val) => {
                setFormulate(val)
              }}
              autoCommands="pi theta sqrt sum prod alpha beta gamma rho backepsilon"
              autoOperatorNames="sin cos tan"
            />
          ) : (
            <BlockMath math={formulate} />
          )}
        </EditorContent>
        <Tips>tips：支持 Latex 语法输入</Tips>
      </Content>
      <Footer>
        <Button
          key="cancel"
          onClick={() => {
            setFocusing(false)
            hide()
          }}
        >
          取消
        </Button>
        <Button
          key="save"
          type="primary"
          onClick={() => {
            setFocusing(false)
            if (formulate) {
              onOk(formulate)
            }
            hide()
          }}
        >
          保存
        </Button>
      </Footer>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  min-height: 300px;
  max-height: 520px;
  overflow: hidden;
`

const Content = styled.div`
  padding: 20px 20px;
`

const EditorContent = styled.div`
  width: 100%;
  min-height: 64px;
  border: 1px solid ${(props) => props.theme.border.greyNormal};
  margin-top: 16px;
  border-radius: 4px;
  padding: 12px;
  &&& {
    .mq-editable-field {
      display: flex;
      width: 100%;
      min-height: 38px;
      align-items: center;
      text-align: center;
      font-size: 17px;
      border-radius: 8px;
    }
    .katex-display {
      margin: 9px 0;
    }
    .katex-html {
      white-space: normal;
    }
    .mq-root-block {
      white-space: normal;
    }
  }
`

const Tips = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${(props) => props.theme.text._3};
`

const Footer = styled.div`
  height: 56px;
  padding: 0 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`
